<div class="login-bg" [style.backgroundImage]="loginBgStyle"></div>
<div class="ir-login-image-wrapper position-absolute top-0 start-0 p-3">
  <img class="ir-login-image" [src]="logoSrc" alt="Logo" width="150" />
</div>
<div class="container d-flex align-items-center justify-content-center vh-100 position-relative overflow-hidden">
  <div class="row justify-content-center w-100">
    <div class="card login-card-wrapper w-100" style="max-width: 500px">
      <div class="card-header text-center border-0 bg-transparent pt-4">
        <h3>{{ 'LOGIN.TITLE' | translate }}</h3>
      </div>
      <div class="card-body">
        <form [formGroup]="loginFormGroup">
          <div class="form-group mb-3">
            <label for="username">{{ 'LOGIN.USER' | translate }}</label>
            <input
              class="form-control"
              id="username"
              placeholder="{{ 'LOGIN.USER' | translate }}"
              formControlName="username"
              required
              [readonly]="loggingIn"
              data-cy="login-username" />
            @if (usernameField?.invalid && usernameField?.touched) {
              <div>
                <small class="text-danger">{{ 'LOGIN.ERROR.INVALID_USERNAME' | translate }}</small>
              </div>
            }
          </div>

          <div class="form-group mb-3 position-relative">
            <label for="password">{{ 'LOGIN.PASS' | translate }}</label>
            <div class="d-flex align-items-center">
              <input
                class="form-control w-100"
                id="password"
                [type]="passwordFieldType"
                placeholder="{{ 'LOGIN.PASS' | translate }}"
                formControlName="password"
                required
                [readonly]="loggingIn"
                data-cy="login-password" />
              <span class="position-absolute end-0 me-3 mt-3 cursor-pointer eye-icon" (click)="togglePasswordVisibility()">
                <i class="material-icons">{{ passwordFieldType === 'password' ? 'visibility' : 'visibility_off' }}</i>
              </span>
            </div>
            @if (passwordField?.invalid && passwordField?.touched) {
              <div>
                <small class="text-danger">{{ 'LOGIN.ERROR.INVALID_PASSWORD' | translate }}</small>
              </div>
            }
          </div>
          <div class="d-flex justify-content-between align-items-baseline mb-3">
            <div class="form-check">
              <small>
                <input type="checkbox" class="form-check-input" id="rememberMe" formControlName="rememberMe" />
                <label class="form-check-label" for="rememberMe">
                  {{ 'LOGIN.REMEMBER_ME' | translate }}
                </label>
              </small>
            </div>
            <div>
              <small>
                <a [routerLink]="['/password-recovery']">{{ 'LOGIN.PASS_RECOVERY' | translate }}</a>
              </small>
            </div>
          </div>
          <div class="form-actions">
            <button class="btn btn-primary btn-lg w-100" [disabled]="loggingIn" (click)="logIn()" data-cy="login-btn">
              {{ (loggingIn ? 'LOGIN.LOGGING_IN' : 'LOGIN.TITLE') | translate }}
            </button>
          </div>

          <!-- SSO divider -->
          <div class="d-flex align-items-center my-3">
            <hr class="flex-grow-1" />
            <span class="px-2 text-muted small">{{ 'LOGIN.SSO_OR_DIVIDER' | translate }}</span>
            <hr class="flex-grow-1" />
          </div>

          <!-- SSO Login button -->
          <button type="button" class="sso-btn w-100" (click)="loginWithSSO()" data-cy="sso-login-btn">
            <i class="material-icons sso-btn__icon">shield</i>
            <span class="sso-btn__text">{{ 'LOGIN.SSO_BUTTON' | translate }}</span>
          </button>

          <div class="text-center mt-3">
            <a class="text-muted small" [href]="requestAccessMailto" [attr.aria-label]="'LOGIN.REQUEST_ACCESS' | translate">
              {{ 'LOGIN.REQUEST_ACCESS' | translate }}
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
